<template>
  <v-row>
    <v-col
      v-for="card in cards"
      :key="card.title"
      cols="12"
      :sm="6"
      :md="card.cols"
      class="pa-2"
    >
      <DashCard
        :title="card.title"
        :value="card.value"
        :valueColor="card.color"
        :loading="dashEventLoading"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import DashCard from "@/components/cards/DashCardEvent.vue";

export default {
  name: "DashInfoModal",
  components: { DashCard },
  props: {
    type: {
      type: String,
      default: "tickets",
    },
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      "saleTicket",
      "isOpenModal",
    ]),
    tickets() {
      return [
        {
          title: this.$t("producer-dashboard.total-revenue"),
          value: this.totalInvoincing.value,
          color: this.totalInvoincing.class,
          cols: 3,
        },
        {
          title: this.itemsSoldText,
          value: this.totalSold.value,
          color: this.totalSold.class,
          cols: 3,
        },
        {
          title: this.eventsSoldText,
          value: this.todaySold.value,
          color: this.todaySold.class,
          cols: 3,
        },
        {
          title: this.$t("producer-dashboard.sold-percentage"),
          value: this.percentSold.value,
          color: this.percentSold.class,
          cols: 3,
        },
        {
          title: this.eventsAvailableText,
          value: this.ableTickets.value,
          color: this.ableTickets.class,
          cols: 4,
        },
        {
          title: this.$t("producer-dashboard.average-ticket"),
          value: this.middleTicket.value,
          color: this.middleTicket.class,
          cols: 4,
        },
        {
          title: this.$t("producer-dashboard.courtesies"),
          value: this.courtesy.value,
          color: this.courtesy.class,
          cols: 4,
        },
      ];
    },
    products() {
      return [
        {
          title: this.$t("producer-dashboard.total-revenue"),
          value: this.formatCurrency(
            this.dashEvent?.produto?.total_vendas || 0
          ),
          color: "positive-percent",
          cols: 6,
        },
        {
          title: this.$t("producer-dashboard.sold-products"),
          value: this.dashEvent?.produto?.qtd_vendas || 0,
          color: "positive-percent",
          cols: 6,
        },
      ];
    },
    recharges() {
      return [
        {
          title: this.$t("producer-dashboard.total-revenue"),
          value: this.formatCurrency(
            this.dashEvent?.recarga?.total_vendas || 0
          ),
          color: "positive-percent",
          cols: 6,
        },
        {
          title: this.$t("producer-dashboard.sold-recharges"),
          value: this.dashEvent?.recarga?.qtd_vendas || 0,
          color: "positive-percent",
          cols: 6,
        },
      ];
    },
    cards() {
      return this.type === "tickets"
        ? this.tickets
        : this.type === "products"
        ? this.products
        : this.recharges;
    },
    rechargeEvents() {
      return JSON.parse(localStorage.getItem("evento")).tipo === "RECARGA";
    },
    productEvents() {
      return JSON.parse(localStorage.getItem("evento")).tipo === "VOUCHER";
    },
    itemsSoldText() {
      return this.rechargeEvents
        ? this.$t("producer-dashboard.sold-recharges")
        : this.productEvents
        ? this.$t("producer-dashboard.sold-products")
        : this.$t("producer-dashboard.sold-tickets");
    },
    eventsSoldText() {
      return this.rechargeEvents
        ? this.$t("producer-dashboard.sold-recharges-today")
        : this.productEvents
        ? this.$t("producer-dashboard.sold-products-today")
        : this.$t("producer-dashboard.sold-today");
    },
    eventsAvailableText() {
      return this.rechargeEvents
        ? this.$t("producer-dashboard.available-recharges")
        : this.productEvents
        ? this.$t("producer-dashboard.available-products")
        : this.$t("producer-dashboard.available-tickets");
    },
    percentsSold() {
      if (Math.sign(this.dashEvent.percentual) === -1) {
        return {
          values: Math.round(this.dashEvent.percentual) + "%",
          class: "negative-percent",
          text: this.$t("producer-dashboard.sold-percentage"),
        };
      } else {
        return {
          values: Math.round(this.dashEvent.percentual) + "%",
          class: "positive-percent",
          text: this.$t("producer-dashboard.sold-percentage"),
        };
      }
    },
    ticketsAvailable() {
      const todaySold = Number.parseFloat(this.dashEvent.ingressos_disponiveis);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(todaySold)
      );

      if (Math.sign(todaySold) === -1) {
        return {
          values: `-${formattedValue}`,
          class: "negative-percent",
          text: this.$t("producer-dashboard.available"),
        };
      } else {
        return {
          values: formattedValue,
          class: "positive-percent",
          text: this.$t("producer-dashboard.available"),
        };
      }
    },
    averageTicket() {
      if (Math.sign(this.dashEvent.ticket_medio) === -1) {
        return {
          values: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "negative-percent",
          text: this.$t("producer-dashboard.average-ticket"),
        };
      } else {
        return {
          values: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "positive-percent",
          text: this.$t("producer-dashboard.average-ticket"),
        };
      }
    },
    totalInvoincing() {
      if (Math.sign(this.dashEvent.faturamento_total) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "positive-percent",
        };
      }
    },
    middleTicket() {
      if (Math.sign(this.dashEvent.ticket_medio) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "positive-percent",
        };
      }
    },
    totalSold() {
      const totalSold = Number.parseFloat(this.dashEvent.total_vendido);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(totalSold)
      );

      if (Math.sign(totalSold) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    todaySold() {
      const cortesiasTotais = Number.parseFloat(this.dashEvent.vendidos_hoje);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesiasTotais)
      );

      if (Math.sign(cortesiasTotais) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    courtesy() {
      const cortesiasTotais = Number.parseFloat(
        this.dashEvent.cortesias_totais
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesiasTotais)
      );

      if (Math.sign(cortesiasTotais) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    ableTickets() {
      const disponiveis = Number.parseFloat(
        this.dashEvent.ingressos_disponiveis
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(disponiveis)
      );

      if (Math.sign(disponiveis) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },
    percentSold() {
      if (Math.sign(this.dashEvent.percentual) === -1) {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "positive-percent",
        };
      }
    },
  },
  methods: {
    formatCurrency(value) {
      return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number.parseFloat(value));
    },
  },
};
</script>

<style scoped></style>
